/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { PostJobCommentPayload } from 'api/actions/post-job-comment/post-job-comment-payload';
import { PostJobCommentPathParameters } from 'api/actions/post-job-comment/post-job-comment-path-parameters';
import { PostJobCommentResponse } from 'api/actions/post-job-comment/post-job-comment-response';

type PostJobCommentQueryParameters = Record<string, any>;

/**
 * The path of the PostJobComment action.
 */
export const postJobCommentActionPath = new SweetPath<keyof PostJobCommentPathParameters>(
  '/help-desk/jobs/{jobId}/comments',
  { path: '{param}' }
);

/**
 * Creates a contextualized PostJobComment actions.
 */
export default function createPostJobCommentAction(axios: AxiosInstance) {
  return function postJobCommentAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: PostJobCommentPathParameters;
    query?: PostJobCommentQueryParameters;
    payload: PostJobCommentPayload;
  }) {
    const path = postJobCommentActionPath.insert(parameters);

    return axios.post<PostJobCommentResponse, PostJobCommentResponse, PostJobCommentPayload>(path, payload);
  };
}
